import React, { useRef, useState } from 'react';
import "../Applications.css";
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from "yup";
import TextInput from '../../../components/InputFields/TextInput';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { sendTextMessage } from '../../../api/Applications';
import { handleFileUpload } from '../../../utils/ImageToBase64';
import Loader from '../../../components/Loader/Loader';
import { decryptData } from '../../../utils/helper';

const ComposeMessage = ({ getApplication, application, setIsComposeText }) => {
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);

    let user = useSelector((state) => state.userReducer.user);
    const dispatch = useDispatch();
    let token = useSelector((state) => state.userReducer.token);

    const patientPhoneNumber = application?.patientData?.telecom?.find((obj) => obj?.system === "homePhone")
        ? decryptData(application?.patientData?.telecom?.find((obj) => obj?.system === "homePhone")?.value)
        : "";

    const formik = useFormik({
        initialValues: {
            to: patientPhoneNumber,
            message: '',
            attachments: []  // Now an array
        },
        validationSchema: Yup.object({
            to: Yup.string().required('To is required'),
            message: Yup.string().required('Message is required')
        }),
        onSubmit: async (values) => {
            let uploadedFiles = [];
            if (values.attachments.length > 0) {
                for (const file of values.attachments) {
                    const base64File = await handleFileUpload(file);
                    uploadedFiles.push({
                        base64String: base64File,
                        extension: file.type.split("/")[1],
                        name: file.name
                    });
                }
            }

            let payload = {
                message: values.message,
                to: patientPhoneNumber,
                senderId: user?._id,
                applicationId: application?._id,
                attachments: uploadedFiles
            };

            try {
                setIsLoading(true);
                let res = await sendTextMessage({ payload, dispatch, token });

                if (res?.status === "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    await getApplication();
                    formik.resetForm();
                    setIsComposeText(false);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                failed("Failed to send message");
                setIsLoading(false);
            }
        }
    });

    return (
        <>
            <div className='composed_message'>
                {isLoading ? <Loader /> : null}
                <button onClick={()=>setIsComposeText(false)}>back</button>
                <Form onSubmit={formik.handleSubmit} className="form_schedule">
                    <div className='row mb-4'>
                        <div className='col-md-4'>
                            <FormGroup>
                                <Label for="to">To</Label>
                                <TextInput
                                    keyField={"to"}
                                    formik={formik}
                                    label="Primary Phone"
                                    type="phone"
                                    readOnly={true}
                                    value={formik.values.to}
                                    onChange={(e) => formik.setFieldValue("to", e)}
                                />
                                {formik.touched.to && formik.errors.to ? (
                                    <div className="error">{formik.errors.to}</div>
                                ) : null}
                            </FormGroup>
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-6'>
                            <FormGroup>
                                <Label for="message">Message</Label>
                                <Input
                                    id="message"
                                    name="message"
                                    type="textarea"
                                    rows="5"
                                    placeholder="Type your message here..."
                                    value={formik.values.message}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.message && formik.errors.message ? (
                                    <div className="error">{formik.errors.message}</div>
                                ) : null}
                            </FormGroup>
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-6'>
                            <FormGroup>
                                <Label for="attachments">Attachments
                                    <span className="material-symbols-outlined file_upload" >
                                        attach_file
                                    </span>
                                </Label>
                                <input
                                    id="attachments"
                                    ref={fileInputRef}
                                    accept="image/png, image/jpeg"
                                    name="attachments"
                                    type="file"
                                    multiple  // Allow multiple file selection
                                    style={{ display: "none" }}
                                    onChange={(event) => {
                                        const files = Array.from(event.target.files);
                                        formik.setFieldValue("attachments", [...formik.values.attachments, ...files]);
                                    }}
                                />
                                {formik.values.attachments.length > 0 && (
                                    <div className='attachment_list'>
                                        {formik.values.attachments.map((file, index) => (
                                            <div key={index} className='d-flex gap-2 align-items-center'>
                                                <div className='upload_blkkkk d-flex gap-3 justify-content-center flex-grow-1'>
                                                    {file.name} <i className="fa fa-download"></i>
                                                </div>
                                                <i className="material-icons cancel" onClick={() => {
                                                    const newFiles = formik.values.attachments.filter((_, i) => i !== index);
                                                    formik.setFieldValue("attachments", newFiles);
                                                }}>cancel</i>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FormGroup>
                            <button className='send_file' type="submit">Send</button>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
};

export default ComposeMessage;
